<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="sales"
      item-key="id"
      :footer-props="{ 'items-per-page-options': [50], 'items-per-page-text': 'Ventas por Página'}"
      class="elevation-1">

      <!-- Columna Cantidad -->
      <template v-slot:item.quantity="{ item }" class="align-center">
        <div class="text-right">
          {{ item.quantity }}
        </div>
      </template>

      <!-- Columna Subtotal -->
      <template v-slot:item.subtotal="{ item }" class="align-center">
        <div class="text-right">
          {{ item.subtotal | toFixNumber(2) | numberWithComma | prefix('$') }}
        </div>
      </template>

      <!-- Columna Total -->
      <template v-slot:item.total="{ item }" class="align-center">
        <div class="text-right">
          {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
        </div>
      </template>

      </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    dates: {
      type: Array,
      required: true
    },
    period: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      headers: [
        { text: 'Platillo/Artículo', align: 'left', value: 'recipeName', sortable: false },
        { text: 'Cantidad', align: 'left', value: 'quantity', sortable: false },
        { text: 'Subtotal', align: 'left', value: 'subtotal', sortable: false },
        { text: 'Total', align: 'left', value: 'total', sortable: false }
        // { text: '%', align: 'center', value: 'percent', sortable: false }
      ],
      sales: [],
      overlay: false
    }
  },
  computed: {
    ...mapGetters(['restaurant'])
  },
  async mounted () {
    await this.getSalesAfterTax()
  },
  methods: {
    async getSalesAfterTax () {
      let [ fromDate ] = this.dates
      this.overlay = true
      try {
        const salesByDish = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/reports/sales-by-dish`, {
          date: fromDate,
          type: this.period
        })
        this.sales = salesByDish
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  },
  watch: {
    dates: function () {
      this.getSalesAfterTax()
    },
    period () {
      this.getSalesAfterTax()
    }
  }
}
</script>
